module.exports = __webpack_public_path__ + "dbaf40438836897105274aa2c63415a8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SideBar/images/logo.png
 ** module id = 1658
 ** module chunks = 0
 **/